var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0"},[_c('v-card',{attrs:{"flat":""}},_vm._l((_vm.ebooks),function(item,index){return _c('div',{key:index},[_c('ButtonArray',{attrs:{"text":"left","options":_vm.getOptions(item)}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }